package com.arenaproplay.admin.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.arenaproplay.admin.navigation.Routes
import com.arenaproplay.admin.ui.utils.encodeQueryValue
import com.arenaproplay.admin.ui.utils.urlParam

/**
 * Legacy /acquisition route — redirects to /analytics?tab=acquisition.
 *
 * Content has fully moved to the «Привлечение» tab of AnalyticsPage (R5).
 * This stub keeps old bookmarks/external links working.
 */
@Page("/acquisition")
@Composable
fun AcquisitionPage() {
    val ctx = rememberPageContext()
    LaunchedEffect(Unit) {
        val period = urlParam("period")?.let { "&period=${encodeQueryValue(it)}" } ?: ""
        ctx.router.navigateTo("${Routes.ANALYTICS}?tab=acquisition$period")
    }
}
